import Papa from 'papaparse';
import { dataObject } from './object.type';

interface ParsedCsvResult {
    data: dataObject[];
    missingHeaders?: string[];
    errors: Papa.ParseError[];
    meta: Papa.ParseMeta;
}

export const fileParser = (
    file: File,
    headers: string[]
): Promise<ParsedCsvResult> => {
    return new Promise(resolve => {
        Papa.parse(file, {
            complete: result => {
                const validatedResult: ParsedCsvResult = {
                    ...result,
                    data: result.data as dataObject[],
                };
                if (result.meta && result.meta.fields) {
                    const missingHeaders = headers.filter(
                        header => !result.meta.fields?.includes(header)
                    );
                    if (missingHeaders.length > 0) {
                        validatedResult.missingHeaders = missingHeaders;
                        validatedResult.errors = [
                            {
                                type: 'FieldMismatch',
                                code: 'TooFewFields',
                                message: `CSV file is missing expected headers: ${missingHeaders.join(
                                    ', '
                                )}`,
                            },
                        ];
                    }
                } else {
                    validatedResult.errors = [
                        {
                            type: 'FieldMismatch',
                            code: 'TooFewFields',
                            message: 'CSV file does not contain headers',
                        },
                    ];
                }
                resolve(validatedResult);
            },
            header: true, // Assuming the first row contains headers
            dynamicTyping: false, // Convert numeric and boolean strings to their types
            skipEmptyLines: true, // Skip empty lines
            delimitersToGuess: [
                ',',
                '\t',
                '|',
                ';',
                Papa.RECORD_SEP,
                Papa.UNIT_SEP,
            ],
        });
    });
};
